export const buttonBaseStyle = {
    padding: "1px",        
    fontSize: "0.75rem",  
    height: "30px",       
    width: "30px",       
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
};

export const chooseOptions = {
    label: 'Elegir archivo',
    icon: 'pi pi-fw pi-file-pdf',
    iconOnly: false,
    className: 'p-button-outlined',
    style: { 
        ...buttonBaseStyle, 
        backgroundColor: '#51aee3', 
        color: 'white', 
        width: 'auto', 
        padding: '0 6px',   
        fontSize: '0.75rem'  
    },
};

export const uploadOptions = {
    icon: 'fa fa-floppy-o',
    iconOnly: true,
    className: 'p-button-outlined',
    style: { ...buttonBaseStyle, backgroundColor: '#145b8b', color: 'white' },
};
